import React from 'react'

export const collegeColumns = (layout, role, handleEdit) => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		width: '15%'
	},
	{
		name: 'College Name',
		selector: (row) => row.collegename || '',
		sortable: true,
		width: '50%',
		cell: (row) => <div className="text-truncate">{row.collegename || 'N/A'}</div>
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '30%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<button onClick={() => handleEdit(row)} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</button>
				{row.onDelete && (
					<button className="btn btn-danger btn-sm" onClick={row.onDelete}>
						 <i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
